import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconMinus = ({ color = colors.black }) => {
    return <svg width='12' height='2' viewBox='0 0 12 2' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M0 0H12V2H0V0Z' fill={color} />
    </svg>;
};

IconMinus.propTypes = {
    color: PropTypes.string
};

export default IconMinus;
